import { HugeiconsIcon } from '@hugeicons/react'
import { Delete01Icon } from '@hugeicons/core-free-icons'
import { useState } from 'react'
import { RemoveUserDialog } from './RemoveUserDialog'
import { Button } from '@/components/ui/button'

interface RemoveUserButtonProps {
  userId: string
  userName: string
  children?: React.ReactNode
  onSuccess?: () => void
}

export const RemoveUserButton = ({
  userId,
  userName,
  children,
  onSuccess,
}: RemoveUserButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Button
        onClick={() => setDialogOpen(true)}
        variant="destructive"
        size="sm"
      >
        {children || (
          <>
            <HugeiconsIcon icon={Delete01Icon} className="h-4 w-4 mr-2" />
            Remove
          </>
        )}
      </Button>

      <RemoveUserDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        userId={userId}
        userName={userName}
        onSuccess={onSuccess}
      />
    </>
  )
}
